

<div class="bg-white dark:bg-slate-800 w-full mx-auto p-8 rounded-xl">
    
    <mat-form-field [subscriptSizing]="'dynamic'" floatLabel="always" class="w-full">
        <mat-icon matIconPrefix [svgIcon]="'tabler_outline:mail'"></mat-icon>
        <mat-label>Email address</mat-label>
        <input type="email" lowercaseEmail matInput [formControl]="loginForm.controls.emailAddress" placeholder="Email address">
        <mat-error *ngIf="loginForm.controls.emailAddress.touched && loginForm.controls.emailAddress?.errors?.invalidEmail">Invalid email address</mat-error>
    </mat-form-field>

    <mat-form-field [subscriptSizing]="'dynamic'" floatLabel="always" class="w-full mt-4">
        <mat-icon matIconPrefix [svgIcon]="'tabler_outline:lock'"></mat-icon>
        <mat-label>Password</mat-label>
        <input (keyup.enter)="login()" [type]="showPassword ? 'text' : 'password'" matInput [formControl]="loginForm.controls.password" placeholder="Password">
        <button mat-icon-button matSuffix (click)="showPassword = !showPassword">
            <mat-icon [svgIcon]="showPassword ? 'tabler_outline:eye-off' : 'tabler_outline:eye'"></mat-icon>
        </button>
        <mat-error *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.['minlength']">Password must be at leat 8 characters long.</mat-error>
    </mat-form-field>

    <button mat-flat-button color="primary" [disabled]="isProcessing" class="mt-6 w-full" (click)="login()">
        <mat-icon class="icn-spinner mr-2" *ngIf="isProcessing == true" [svgIcon]="'tabler_outline:loader'"></mat-icon>
        <span class="ml-2" *ngIf="isProcessing == true">Logging in</span>
        <span *ngIf="isProcessing == false" class="ml-2">Log in</span>
    </button>
</div>
   

